/**
 * YMQ Custom — Collection / search product cards
 *
 * YMQ app embed injects `.button-quote-price` on listing cards for quote products.
 * Replace quick-add with a theme "詳細はこちら" link to the product page.
 */
(function () {
  const DETAILS_ATTR = "data-product-card-details";
  const PROCESSED_ATTR = "data-ymq-card-processed";

  function getProductUrl(card) {
    const link = card.querySelector('a.product-card__link[href*="/products/"]');
    return link?.href || null;
  }

  function getDetailsLabel(card) {
    const existing = card.querySelector(`[${DETAILS_ATTR}] .quick-add__button-text span span`);
    if (existing?.textContent?.trim()) return existing.textContent.trim();
    return "詳細はこちら";
  }

  function buildDetailsButton(url, label) {
    const wrapper = document.createElement("div");
    wrapper.className = "quick-add quick-add--details";
    wrapper.setAttribute(DETAILS_ATTR, "");

    const link = document.createElement("a");
    link.href = url;
    link.className =
      "button quick-add__button quick-add__button--details";
    link.innerHTML = `
      <span class="add-to-cart-text quick-add__button-content">
        <span class="add-to-cart-text__content quick-add__button-text">
          <span><span></span></span>
        </span>
      </span>
    `;
    link.querySelector("span span span").textContent = label;

    wrapper.appendChild(link);
    return wrapper;
  }

  function processCard(card) {
    if (!(card instanceof HTMLElement)) return;
    if (card.getAttribute(PROCESSED_ATTR) === "true") return;
    if (card.querySelector(`[${DETAILS_ATTR}]`)) {
      card.setAttribute(PROCESSED_ATTR, "true");
      return;
    }

    const quoteBtn = card.querySelector(".button-quote-price");
    if (!quoteBtn) return;

    const productUrl = getProductUrl(card);
    if (!productUrl) return;

    card.setAttribute(PROCESSED_ATTR, "true");

    const quickAdd = card.querySelector("quick-add-component");
    if (quickAdd) quickAdd.hidden = true;

    quoteBtn.hidden = true;

    const host = card.querySelector(".card-gallery") || card;
    host.appendChild(buildDetailsButton(productUrl, getDetailsLabel(card)));
  }

  function scan(root = document) {
    root.querySelectorAll("product-card").forEach(processCard);
  }

  function init() {
    scan();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.closest?.("ymq-option, .ymq-custom-modal-wrapper, .ymq-app-select-content")) {
            continue;
          }

          if (node.matches("product-card")) {
            processCard(node);
            continue;
          }

          if (node.matches(".button-quote-price")) {
            const card = node.closest("product-card");
            if (card) processCard(card);
            continue;
          }

          node.querySelectorAll?.("product-card").forEach(processCard);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
